import React, { useMemo } from 'react';
import Col from '../../Col';
import Row from '../../Row';
import Checkbox from '../../Checkbox';

interface ModulePermissionsSectionProps {
  tabList: any[];
  selectedModulePermissions: any[];
  onSetModules: (moduleId: any) => void;
}

const ModulePermissionsSection = ({
  tabList,
  selectedModulePermissions,
  onSetModules,
}: ModulePermissionsSectionProps) => {
  const selectedIds: Set<any> = useMemo(
    () =>
      new Set(
        (selectedModulePermissions ?? [])
          .map((permission: any) => permission?.Id)
          .filter((id: any) => id != null)
      ),
    [selectedModulePermissions]
  );

  return (
    <div style={{ marginTop: '1.5rem' }}>
      <label className="input__label">
        Permissions<span style={{ color: 'red' }}>*</span>
      </label>
      <br />
      <Row>
        {tabList.map((tab: any) => {
          const isSelected: boolean = selectedIds.has(tab.id);

          return (
            <Col
              key={tab.id}
              xs="12"
              sm="12"
              md="6"
              lg="6"
              style={{ marginTop: '0.25rem' }}
            >
              <Checkbox
                checked={isSelected}
                name={isSelected ? tab.id : null}
                value={isSelected ? tab.id : ''}
                label={tab.name}
                onChange={() => onSetModules(tab.id)}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ModulePermissionsSection;
